import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "gdzieschronisko_cookie_consent";

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consent) {
        // Delay showing banner for better UX
        const timer = setTimeout(() => setIsVisible(true), 500);
        return () => clearTimeout(timer);
      }
    };
    
    checkConsent();

    // Listen for reset event
    const handleReset = () => {
      setIsVisible(true);
    };
    
    window.addEventListener("cookie-consent-reset", handleReset);
    return () => window.removeEventListener("cookie-consent-reset", handleReset);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event("cookie-consent-change"));
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event("cookie-consent-change"));
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[1001] p-4 animate-fade-in">
      <div className="relative max-w-4xl mx-auto bg-card border border-border rounded-xl shadow-elevated p-4 pr-10 sm:p-6 sm:pr-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Cookie className="w-5 h-5 text-primary" />
          </div>
          
          <div className="flex-1">
            <p className="text-sm text-foreground leading-relaxed">
              Używamy plików cookies i przetwarzamy dane lokalizacyjne, aby zapewnić najlepsze doświadczenie 
              korzystania z serwisu. Korzystając ze strony, wyrażasz zgodę na ich używanie zgodnie z naszą{" "}
              <Link to="/polityka-prywatnosci" className="text-primary hover:underline font-medium">
                polityką prywatności
              </Link>.
            </p>
          </div>
          
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="flex-1 sm:flex-none"
            >
              Odrzuć
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="flex-1 sm:flex-none"
            >
              Akceptuję
            </Button>
          </div>
          
          <button
            onClick={handleDecline}
            className="absolute top-2 right-2 sm:static p-1.5 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Zamknij"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
